{
  "meta": {
    "business": {
      "title": "money2me — кэшбэк, который возвращает клиентов",
      "description": "money2me — сервис кэшбэка для бизнеса. Клиенты платят по QR и получают кэшбэк, а вы получаете гостей, которые возвращаются снова."
    },
    "app": {
      "title": "money2me — кэшбэк за покупки и оплата по QR",
      "description": "Привяжите карту, платите по QR и получайте кэшбэк за покупки с money2me. Бонусы, история покупок и карта заведений — в одном приложении."
    },
    "point": {
      "title": "money2me — кэшбэк и акции этой точки",
      "description": "Предложения, акции и ваш кэшбэк в этой точке — в приложении money2me."
    }
  },
  "header": {
    "nav": {
      "label": "Основная навигация",
      "toggle": "Открыть меню",
      "close": "Закрыть меню",
      "howItWorks": "Как это работает",
      "advantages": "Преимущества",
      "benefits": "Выгода",
      "faq": "FAQ",
      "app": "Приложение",
      "business": "Для торговых точек"
    },
    "cta": {
      "apply": "Оставить заявку",
      "download": "Скачать"
    },
    "language": "Язык"
  },
  "hero": {
    "title": "Кэшбэк, который возвращает клиентов",
    "description": "Клиенты платят по QR и получают кэшбэк за покупку.",
    "mobileDescription": "Привяжите карту, платите по QR и получайте до 10% кешбэка.",
    "primaryCta": "Подключить бизнес",
    "secondaryCta": "Рассчитать выгоду",
    "categories": [
      "Бары и кофейни",
      "Кафе и рестораны",
      "Барбершопы и салоны",
      "Магазины и ритейл",
      "Кондитерские и пекарни",
      "Аптеки",
      "Фитнес и спорт",
      "Автосервис и мойки",
      "Цветы и подарки",
      "Детские товары",
      "Электроника"
    ]
  },
  "guestJourney": {
    "title": "Что делает ваш гость",
    "description": "Всё, что нужно, — телефон. И три простых шага:",
    "steps": [
      {
        "title": "Оплачивает покупку",
        "description": "Привязывает карту один раз и платит, отсканировав ваш QR-код."
      },
      {
        "title": "Получает бонусы",
        "description": "Часть потраченной суммы возвращается ему бонусами."
      },
      {
        "title": "Приходит снова",
        "description": "Потратить их можно только у вас — это и приводит гостя обратно."
      }
    ]
  },
  "whyMoney2me": {
    "title": "Реклама приводит клиента один раз. А дальше?",
    "description1": "Вы платите за привлечение, гость приходит — и не возвращается.",
    "description2": "money2me меняет логику: вы вкладываетесь не в показы, а в возврат клиентов.",
    "mobileDescription": "money2me привлекает новых клиентов и помогает их возвращать.",
    "money2me": {
      "title": "money2me",
      "items": [
        "Кэшбэк мотивирует клиента вернуться именно к вам",
        "Новые гости находят вас в каталоге приложения",
        "Гибкая ставка кэшбэка по точке и категории",
        "Прозрачная статистика по каждой оплате"
      ]
    },
    "ads": {
      "title": "Обычная реклама",
      "items": [
        "Платите за клики и показы, а не за клиентов",
        "Гость приходит один раз и забывает о вас",
        "Непонятно, какая реклама реально окупилась",
        "Нужен бюджет вперёд, без гарантии результата"
      ]
    }
  },
  "howItWorks": {
    "title": "Как это работает для бизнеса?",
    "description": "Никаких касс, терминалов и сложных интеграций. Достаточно QR-кода на стойке.",
    "steps": [
      {
        "badge": "Шаг 1",
        "title": "Заявка",
        "description": "Заполните короткую форму. Это первый шаг — без регистрации и обязательств."
      },
      {
        "badge": "Шаг 2",
        "title": "Подключение",
        "description": "Менеджер проверит данные и согласует условия подключения."
      },
      {
        "badge": "Шаг 3",
        "title": "Публикация",
        "description": "Заведение появится в каталоге с вашим предложением и кэшбэком."
      },
      {
        "badge": "Шаг 4",
        "title": "Покупка и кэшбэк",
        "description": "Гость оплачивает покупку по QR, получает кэшбэк и возвращается снова."
      }
    ]
  },
  "growthTool": {
    "title": "Инструмент роста, а не ещё одна статья расходов",
    "description": "Никаких касс, терминалов и сложных интеграций. Достаточно QR-кода на стойке.",
    "newClients": {
      "title": "Новые клиенты",
      "description": "Клиенты ищут, где получить кэшбэк, и находят вас в каталоге money2me."
    },
    "transparentOperations": {
      "title": "Прозрачные операции",
      "description": "Обороты, гости и средний чек по каждой точке — всё видно."
    },
    "flexibleRate": {
      "title": "Гибкая ставка кэшбэка",
      "description": "Своя ставка кэшбэка для каждой точки и категории товаров."
    },
    "notADiscount": {
      "title": "Кэшбэк, а не скидка",
      "description": "Клиент видит обычную цену, а кэшбэк начисляется из вашей маржи."
    },
    "qrPayment": {
      "title": "Оплата картой по QR",
      "description": "Клиент платит картой, отсканировав QR. Без терминала и кассы."
    },
    "promotions": {
      "title": "Продвижение и акции",
      "description": "Запускайте акции в приложении и приводите гостей в нужный момент."
    },
    "model": {
      "title": "Как устроена модель?",
      "description": "Обычная цена плюс кэшбэк из вашей маржи. Клиент видит чистую цену, кэшбэк (например, 10%) — отдельно. Это кэшбэк, а не скидка.",
      "clientPrice": "Клиент видит цену",
      "cashbackShare": "Кешбэк из вашей маржи",
      "clientReturn": "Возврат клиенту"
    }
  },
  "stats": {
    "title": "Что это дает бизнесу?",
    "items": [
      {
        "value": "10%",
        "label": "Кэшбэк клиенту за оплату"
      },
      {
        "value": "×2",
        "label": "Частота повторных визитов"
      },
      {
        "value": "+20%",
        "label": "Средний прирост выручки"
      },
      {
        "value": "1 день",
        "label": "На подключение и запуск"
      }
    ]
  },
  "faq": {
    "title": "FAQ",
    "items": [
      {
        "question": "Как подключиться к money2me?",
        "answer": "Оставьте заявку — менеджер свяжется, согласует условия и поможет с настройкой. Нужен только QR-код на стойке, оборудование не требуется."
      },
      {
        "question": "Можно настроить разный кэшбэк?",
        "answer": "Да. Ставку кэшбэка можно задать отдельно для каждой точки и категории товаров или услуг."
      },
      {
        "question": "Кто платит кэшбэк?",
        "answer": "Кэшбэк начисляется из вашей маржи — как часть стоимости покупки, а не как отдельная скидка сверху."
      },
      {
        "question": "Как и когда деньги попадают на мой счёт?",
        "answer": "Оплаты поступают на ваш расчётный счёт по графику выплат, который согласовывается при подключении."
      },
      {
        "question": "Можно ли отключиться в любой момент?",
        "answer": "Да, вы можете отключить приём оплат через money2me в любой момент без штрафов и обязательств."
      },
      {
        "question": "Как мне использовать money2me если я клиент?",
        "answer": "Установите приложение money2me, привяжите карту и оплачивайте покупки по QR-коду на стойке — кэшбэк начислится автоматически."
      }
    ]
  },
  "ctaBanner": {
    "title": "Станьте одним из первых заведений в money2me",
    "description": "Оставьте заявку — менеджер свяжется, ответит на вопросы и поможет с подключением.",
    "cta": "Оставить заявку"
  },
  "footer": {
    "app": {
      "title": "Приложение money2me для ваших клиентов",
      "description": "Оплата картой по QR, кэшбэк за покупки и карта заведений рядом. Платишь как обычно — получаешь больше.",
      "googlePlay": "Скачать в Google Play",
      "appStore": "Скачать в App Store"
    },
    "brand": {
      "title": "money2me",
      "description": "Оплата картой по QR с кэшбэком. Клиенты, которые возвращаются."
    },
    "business": {
      "title": "Бизнесу",
      "howItWorks": "Как это работает",
      "advantages": "Преимущества",
      "apply": "Оставить заявку"
    },
    "appNav": {
      "title": "Приложение",
      "appStore": "App Store",
      "googlePlay": "Google Play"
    },
    "contacts": {
      "title": "Контакты",
      "phone": "+7 (700) 000-00-00",
      "email": "business@moneyto.me"
    },
    "copyright": "© 2026 ТОО «NEOCODE». Все права защищены.",
    "offer": "Оферта",
    "privacy": "Политика конфиденциальности",
    "cardPayment": "Условия оплаты картой"
  },
  "applyForm": {
    "title": "Оставить заявку",
    "description": "Заполните форму — команда свяжется и начнёт проверку",
    "close": "Закрыть",
    "back": "Назад",
    "fields": {
      "contactName": "Контактное лицо",
      "contactNamePlaceholder": "Например, Айгерим",
      "businessName": "Название бизнеса",
      "businessNamePlaceholder": "Например, Coffee Boom",
      "phone": "Номер телефона",
      "phonePlaceholder": "+7 (700) 000-00-00",
      "email": "Email",
      "emailPlaceholder": "you@business.kz",
      "businessType": "Тип бизнеса",
      "businessTypeLegalEntity": "Юр. лицо",
      "businessTypeIndividualEntrepreneur": "ИП",
      "bin": "БИН",
      "binPlaceholder": "12 цифр",
      "category": "Категория бизнеса",
      "categoryPlaceholder": "Выберите категорию",
      "locationsCount": "Количество точек",
      "locationsCountPlaceholder": "Например, 3",
      "cities": "Город",
      "citiesPlaceholder": "Алматы",
      "description": "Описание бизнеса (по желанию)",
      "descriptionPlaceholder": "Пару слов о вашем бизнесе"
    },
    "categories": {
      "FOOD_SERVICE": "Кафе и рестораны",
      "RETAIL": "Продукты и розница",
      "BEAUTY_HEALTH": "Красота и здоровье",
      "SERVICES": "Услуги",
      "FUEL": "АЗС",
      "PHARMACY": "Аптеки",
      "FASHION": "Одежда и обувь",
      "ELECTRONICS": "Электроника",
      "ENTERTAINMENT": "Развлечения и досуг",
      "OTHER": "Прочее"
    },
    "cities": {
      "ALMATY": "Алматы"
    },
    "consent": "Согласен на обработку персональных данных в соответствии с <policy>политикой конфиденциальности</policy>",
    "submit": "Отправить заявку",
    "submitting": "Отправка…",
    "errors": {
      "required": "Заполните это поле",
      "tooLong": "Не более 150 символов",
      "phone": "Некорректный номер",
      "email": "Введите корректный email",
      "emailLength": "Email слишком длинный",
      "bin": "Введите корректный БИН (12 цифр)",
      "category": "Выберите категорию бизнеса",
      "city": "Выберите город",
      "locationsCount": "Укажите хотя бы одну точку",
      "descriptionTooLong": "Не более 500 символов",
      "consent": "Необходимо согласие на обработку данных",
      "submit": "Не удалось отправить заявку. Попробуйте ещё раз."
    },
    "success": {
      "title": "Заявка отправлена",
      "description": "Спасибо! Мы получили вашу заявку и свяжемся с вами, чтобы обсудить подключение.",
      "cta": "Хорошо"
    }
  },
  "appHero": {
    "titleLine1": "Платите как обычно —",
    "titleLine2": "получайте деньги обратно",
    "descriptionLine1": "Привяжите карту, платите по QR",
    "descriptionLine2": "и получайте до 10% кешбэка."
  },
  "appHowTo": {
    "title": "Как начать получать кешбэк",
    "description": "Скачайте приложение, привяжите карту и получайте кэшбэк за покупки — без анкет и новых пластиковых карт.",
    "steps": [
      {
        "title": "Скачайте приложение",
        "description": "Установите money2me.app и зарегистрируйтесь по номеру телефона за минуту."
      },
      {
        "title": "Привяжите карту",
        "description": "Добавьте карту любого банка. Выпускать новую и заполнять анкеты не нужно."
      },
      {
        "title": "Платите по QR",
        "description": "Отсканируйте QR-код на кассе, проверьте сумму и подтвердите оплату."
      },
      {
        "title": "Получайте кэшбэк",
        "description": "Часть суммы вернётся бонусами. Ими можно оплатить до 100% чека."
      }
    ]
  },
  "appMoreCashback": {
    "title": "Больше кэшбэка каждую неделю",
    "description": "Следите за предложениями в сторис и находите места с повышенным кэшбэком.",
    "offers": [
      {
        "badge": "Кешбэк 7%",
        "label": "На уход и красоту"
      },
      {
        "badge": "Кешбэк 5%",
        "label": "На кофе до 12:00"
      },
      {
        "badge": "Кешбэк 7%",
        "label": "На спорт и фитнес"
      },
      {
        "badge": "Кешбэк 5%",
        "label": "На доставку еды вечером"
      },
      {
        "badge": "Бонусы ×3",
        "label": "На продукты в выходные"
      },
      {
        "badge": "Кешбэк 7%",
        "label": "На цветы без повода"
      },
      {
        "badge": "Кешбэк 7%",
        "label": "На детские товары"
      },
      {
        "badge": "Кешбэк 3%",
        "label": "На билеты в кино"
      },
      {
        "badge": "Кешбэк 10%",
        "label": "На всё меню по выходным"
      }
    ]
  },
  "appFeatures": {
    "title": "Всё, что нужно, — в одном приложении",
    "description": "Все инструменты кэшбэка под рукой: бонусы, история покупок и карта заведений рядом.",
    "items": [
      {
        "title": "Бонусы — это деньги",
        "descriptionLine1": "Оплачивайте бонусами",
        "descriptionLine2": "до 100% следующего чека."
      },
      {
        "title": "Чеки и история",
        "descriptionLine1": "Все покупки и электронные",
        "descriptionLine2": "чеки хранятся в приложении."
      },
      {
        "title": "Карта точек рядом",
        "descriptionLine1": "Находите места с кэшбэком",
        "descriptionLine2": "поблизости на карте."
      },
      {
        "title": "Приведи друга",
        "descriptionLine1": "Зовите друзей —",
        "descriptionLine2": "бонусы получают оба."
      },
      {
        "title": "Карта любого банка",
        "descriptionLine1": "Привязывается за секунды.",
        "descriptionLine2": "Платить можно во всей сети money2me."
      },
      {
        "title": "Оплата по QR",
        "descriptionLine1": "Отсканируйте код на кассе",
        "descriptionLine2": "и подтвердите сумму."
      }
    ]
  },
  "appWhyInstall": {
    "title": "Почему стоит установить приложение",
    "description": "Никаких касс, терминалов и сложных интеграций. Достаточно QR-кода на стойке.",
    "items": [
      {
        "value": "До 70%",
        "label": "кэшбэк с покупки"
      },
      {
        "value": "До 100%",
        "label": "можно оплатить бонусами",
        "mobileLabel": "оплаты бонусами"
      },
      {
        "value": "×2",
        "label": "кэшбэк в акциях"
      },
      {
        "value": "1 минута",
        "label": "на регистрацию"
      }
    ]
  },
  "appFaq": {
    "title": "FAQ",
    "items": [
      {
        "question": "Как оплатить по QR?",
        "answer": "Откройте money2me, отсканируйте QR на кассе и подтвердите сумму. Оплата пройдёт с привязанной карты."
      },
      {
        "question": "Когда приходят бонусы?",
        "answer": "Бонусы за покупку начисляются автоматически сразу после оплаты."
      },
      {
        "question": "Можно оплатить весь чек бонусами?",
        "answer": "Да, бонусами можно оплатить до 100% следующего чека."
      },
      {
        "question": "Как и когда деньги попадают на мой счёт?",
        "answer": "Кэшбэк начисляется бонусами в приложении и сразу доступен для оплаты покупок у партнёров."
      },
      {
        "question": "Это бесплатно?",
        "answer": "Да. Установка и использование money2me для клиентов бесплатны — платите только за покупки."
      }
    ]
  },
  "appCta": {
    "titleLine1": "Начните возвращать",
    "titleLine2": "деньги с каждой покупки",
    "description": "Установите money2me — регистрация по номеру телефона за минуту.",
    "cta": "Скачать приложение"
  },
  "downloads": {
    "unavailable": "Скоро"
  },
  "pointQr": {
    "home": "money2me — на главную",
    "title": "Кэшбэк и акции",
    "titleAccent": "этой точки",
    "description": "Предложения точки и ваш кэшбэк — в приложении money2me.",
    "android": {
      "rescan": "После установки отсканируйте QR-код ещё раз — точка откроется в приложении.",
      "openAppHint": "Приложение уже установлено?",
      "openApp": "Открыть в приложении"
    },
    "ios": "Приложение для iPhone скоро появится в App Store. Пока money2me доступно на Android.",
    "desktop": "Откройте эту страницу на телефоне с Android или скачайте приложение в Google Play.",
    "invalid": {
      "title": "Не удалось распознать QR-код",
      "description": "Установите money2me и найдите точку на карте в приложении."
    },
    "about": "Подробнее о money2me"
  },
  "notFound": {
    "title": "Такой страницы нет",
    "description": "Возможно, ссылка устарела или в ней опечатка. Начните с главной страницы money2me.",
    "home": "На главную"
  }
}
